import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle,MatDialogClose,MatDialogActions,MatDialogContent } from '@angular/material';

@Component({
  selector: 'app-infodialog',
  templateUrl: './infodialog.component.html',
  styleUrls: ['./infodialog.component.css']
})
export class InfodialogComponent implements OnInit {

  msg;
  title;
  closemsg;
  constructor(public dialogRef: MatDialogRef<InfodialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      this.msg = data.msg;
      this.closemsg = data.closemsg;
      this.title = data.title;

    }

  ngOnInit() {
  }

}
